import { createContext, useContext } from "react";
import { SourceDocument, ImproveBatchData } from "@/hooks/useImproveBatchLoader";

/**
 * ImproveContext provides orchestration methods for the Improve flow.
 * State is managed in Zustand (improveSlice) and accessed via store selectors.
 * This context only exposes methods that require coordination between multiple systems.
 */
export type ImproveContextType = {
    /** Trigger a reload of the improve batch from Firestore */
    loadImproveBatch: () => Promise<ImproveBatchData | null>;
    /** Get CDN URL for a source image */
    getSourceImageUrl: (source: SourceDocument) => string;
    /** Handle approving the current image - waits for pending syncs, then approves */
    handleApproveImage: () => Promise<void>;
    /** Whether an approval is currently in progress */
    isApproving: boolean;
};

export const ImproveContext = createContext<ImproveContextType>({} as ImproveContextType);

export const useImproveContext = () => {
    return useContext(ImproveContext);
};
